'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/error.ejs');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-error',
    events: {
        'click .btn-close': 'close'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.name = options.name;
    },
    /**
     *
     */
    render: function () {
        var model = {
            copy: this.model,
            name: this.name
        };

        this.$el.html(template(model));
        return this;
    },
    /**
     *
     * @param e
     */
    close: function (e) {
        e.preventDefault();

        if(e.currentTarget.tagName !== 'BUTTON' || this.model.button.route == 'home') {
            PubSub.trigger('directRoute', 'closeCurrentModal');
            PubSub.trigger('userCancelVote');
            return;
        }

        PubSub.trigger('retryVoteAction');
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/error.js